import React, { useState } from "react";
import styles from "../../css/disassociate/DisassociateFacilityFromParent.module.scss";
import { PropTypes } from "prop-types";
import MultiSelectDropdown from "../shared/MultiSelectDropdown";
import MultiSelect from "../shared/MultiSelect";
import ButtonSM from "../shared/ButtonSM";
import { red } from "../../helpers/utils_styles";
import { isEmptyArray } from "../../helpers/utils_types";

// STEPS:
// 1. Select 1 or more facility(s) to be removed from a parent

const customCSS = {
	input: {
		backgroundColor: "#ffffff",
	},
	btn: {
		backgroundColor: red[600],
		color: "#ffffff",
		padding: ".8rem 1.3rem",
		fontSize: "1.6rem",
	},
};

const DisassociateFacilityFromParent = ({
	facilities = [],
	parentsMap = {},
	saveHandler,
}) => {
	const { names } = parentsMap;
	const [selectedFacilities, setSelectedFacilities] = useState([]);

	const handleSelections = (selected) => {
		setSelectedFacilities(selected);
	};

	const handleSave = (e) => {
		saveHandler(selectedFacilities);
	};

	return (
		<div className={styles.DisassociateFacilityFromParent}>
			<div className={styles.DisassociateFacilityFromParent_desc}>
				Remove the association of one or more community from their parent
				community.
			</div>
			<MultiSelect
				key={`DISASSOCIATE-PARENT-${names?.length}`}
				initialSelections={[]}
				options={names}
				disabledOptions={[]}
				handleMultiSelect={handleSelections}
				customStyles={customCSS.input}
			/>
			<div className={styles.DisassociateFacilityFromParent_summary}>
				Running this action will affect <b>{selectedFacilities?.length ?? 0}</b>{" "}
				community(s).
			</div>
			<div className={styles.DisassociateFacilityFromParent_warning}>
				Warning: This action MAY change or alter this community's billing
				situation. It will remove the selected communities from their parent.
			</div>
			<div className={styles.DisassociateFacilityFromParent_actions}>
				<ButtonSM
					isDisabled={isEmptyArray(selectedFacilities)}
					handleClick={handleSave}
					customStyles={customCSS.btn}
				>
					Disassociate From Parent
				</ButtonSM>
			</div>
		</div>
	);
};

export default DisassociateFacilityFromParent;

DisassociateFacilityFromParent.defaultProps = {};

DisassociateFacilityFromParent.propTypes = {};
